export const onboardingShownForScreen = (key) => {
    try {
        let cnt = parseInt(localStorage.getItem(key));
        if (isNaN(cnt)) cnt = 0;
        return cnt;
    } catch (error) {
        captureException(error);
        return 1;
    }
}

export const logOnboardingShown = (key) => {
    const cnt = onboardingShownForScreen(key);
    localStorage.setItem(key, cnt + 1);
}
